import React from 'react';
import { Card } from 'reactstrap';
import { PseudoStates, useFetch } from '@cordata/buffet';

import BigNumberCard from '~/components/common/BigNumberCard';
import { MatchStatus } from '~/utils/const/identity';

import usePatient from '~/utils/patient/hook';

const PlacementCount = () => {
  const [, patient] = usePatient();
  const [s, , meta] = useFetch('data/public/list-view-cs-tbl-source-placement-history', {
    params: {
      patient_uid: patient.id,
      match_status_id: MatchStatus.Approved,
    },
    instance: 'p',
  });

  return s === 'success'
    ? <BigNumberCard title="Placement Count" number={meta.total} />
    : <Card body><PseudoStates status={s} /></Card>;
};

export default PlacementCount;
